module.exports = __webpack_public_path__ + "img/dynamic_Image.f0ad45ee.png";